import { render, staticRenderFns } from "./JielongGoodsCard.vue?vue&type=template&id=c420b1d4&scoped=true"
import script from "./JielongGoodsCard.vue?vue&type=script&lang=ts"
export * from "./JielongGoodsCard.vue?vue&type=script&lang=ts"
import style0 from "./JielongGoodsCard.vue?vue&type=style&index=0&id=c420b1d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c420b1d4",
  null
  
)

export default component.exports